import React from "react";
import { MdRadioButtonUnchecked } from "react-icons/md";
import { MdRadioButtonChecked } from "react-icons/md";

interface RadioTileProps {
  value: boolean;
  children: React.ReactNode;
  onChange: (e: boolean) => void;
}
export const RadioTile = ({ value, children, onChange }: RadioTileProps) => {
  return (
    <label
      onClick={(e) => {
        e.stopPropagation();
        onChange(!value);
      }}
      className="flex cursor-pointer flex-col rounded-md border border-slate-300 p-4 focus:outline-none hover:bg-slate-200 dark:border-slate-600 dark:hover:bg-slate-700"
    >
      <span className="flex items-center text-sm">
        {value ? (
          <MdRadioButtonChecked size={20} />
        ) : (
          <MdRadioButtonUnchecked size={20} />
        )}
        <span className="ml-3 font-medium">{children}</span>
      </span>
    </label>
  );
};
